<template>
  <div v-if="show" class="logs_wrap">
    <div class="arch_log">
      <div class="filters">
        <div class="filter date form-group">
          <WrapDatePicker
            type="date"
            value_type="X"
            :placeholder="translate('log.date_start')"
            v-model="filters.date_start"
            :range="false"
            :confirm="false"
          />
        </div>

        <div class="filter">
          <label class="info"> {{ translate("log.time") }} </label>
          <tree-select
            class="select"
            v-model="params.timezone"
            :options="[
              { label: 'UTC', id: 'UTC' },
              { label: 'Local Time', id: 'Local Time' },
            ]"
            :searchable="false"
            :clearable="false"
            :show-labels="false"
            :close-on-select="true"
            :clear-on-select="false"
            :hide-selected="true"
          />
        </div>

        <div class="filter slider-switch">
          <div class="info">
            {{ translate("log.limit") }}
          </div>
          <label class="switch" @click.prevent="filters.limit = !filters.limit">
            <input type="checkbox" v-model="filters.limit" />
            <span class="slider round"></span>
          </label>
        </div>

        <div class="filter slider-switch">
          <div class="info">
            {{ translate("log.only_warning") }}
          </div>
          <label
            class="switch"
            @click.prevent="filters.only_warning = !filters.only_warning"
          >
            <input type="checkbox" v-model="filters.only_warning" />
            <span class="slider round"></span>
          </label>
        </div>

        <div v-if="String(filters.date_start) === String(todayDefaultDate)"
             class="filter slider-switch">
          <div class="info">
            {{ translate("log.auto_update") }}
          </div>
          <label
            class="switch"
            @click.prevent="filters.update_logs = !filters.update_logs"
          >
            <input type="checkbox" v-model="filters.update_logs" />
            <span class="slider round"></span>
          </label>
        </div>
      </div>

      <date-picker
          v-model="date"
          type="datetime"
          range
          valueType="X"
          :confirm="true"
          @confirm="get_archive"
          :confirmText="translate('config.get_log')"
          :disabled-date="disabledDate"
      >
        <template v-slot:input>
          <button
              id="datepicker-button-trigger"
              type="submit"
              class="mdi btn btn-info archive"
              :class="{ 'mdi-content-save mdi-archive': !loading }"
              :disabled="loading"
          >
            <scale-loader v-if="loading" height="9.5px" width="7.5px" />
            <span v-else> {{ translate("archive.one") }} </span>
          </button>
        </template>
      </date-picker>
    </div>

    <TextTable :all_data="all_data" :params="params" />
  </div>
  <div v-else style="height: 100%">
    <div class="spinner">
      <scale-loader />
    </div>
  </div>
</template>

<script>
import TextTable from "components/UIComponents/Plugins/TextTablePlagin/TextTable.vue";
import WrapDatePicker from "components/UIComponents/WrapDatePicker/WrapDatePicker.vue";

let defaultDate = new Date();
let todayDefaultDate = Math.round(
  +new Date(
    defaultDate.getFullYear(),
    defaultDate.getMonth(),
    defaultDate.getDate()
  ) / 1000
);
export default {
  name: "Logs",
  components: {
    WrapDatePicker,
    TextTable,
  },
  props: ["dev_fid"],
  data() {
    return {
      todayDefaultDate: "",
      loading: false,
      show: false,
      temp: "",
      date: [],
      all_data: {},
      params: {
        timezone: "Local Time",
      },
      filters: {
        date_start: "" + todayDefaultDate,
        limit: true,
        only_warning: false,
        update_logs: false,
      },
    };
  },

  watch: {
    $route() {
      this.show = false;
      clearInterval(this.interval);
      this.check_params();
    },

    filters: {
      deep: true,
      handler: function () {
        this.show = false;
        clearInterval(this.interval);
        this.check_params();
      },
    },
  },

  mounted() {
    this.check_params();
    this.todayDefaultDate = todayDefaultDate;
  },

  computed: {
    datetime_picker() {
      return this.$store.getters.getDatetimePicker;
    },
  },

  beforeDestroy() {
    clearInterval(this.interval);
  },

  methods: {
    check_params() {
      if (this.filters.utc) {
        this.params.timezone = this.filters.utc;
      }

      let body = { format: "array" };
      this.filters.limit ? body.limit = 1000 : ""
      this.filters.only_warning ? body.type = "warnings" : ""

      body.ts_start = +this.filters.date_start;

      this.request(body);
    },
    request(body) {
      if (this.$route.name === "device_section" && this.dev_fid) {
        this.$http.v1.getDeviceLog(this.dev_fid, body, (response) => {
          this.all_data = response.data;
          this.show = true;
        });
        if (this.filters.update_logs === true) {
          this.interval = setInterval(() => {
            this.$http.v1.getDeviceLog(this.dev_fid, body, (response) => {
              this.all_data = response.data;
            });
          }, this.$store.getters.getDeviceLogUpdate);
        }
      }
    },

    get_archive(selectedDate) {
      if (selectedDate.length === 0) {
        let today = new Date();
        today = Math.round(
          new Date(today.getFullYear(), today.getMonth(), today.getDate()) /
            1000
        );

        selectedDate = [today, today + 86399];
      }
      //Если по какой-то причине нет дат, то указываем по умолчанию начало и конец текущего дня

      this.loading = true;
      if (+selectedDate[0] !== 0) {
        let params = {
          start: +selectedDate[0],
          end: +selectedDate[1],
        };
        this.$http.v1.saveDeviceLogs(
          this.dev_fid,
          params,
          (response) => {
            let blob = new Blob([response.data]);
            let link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            let date1 = new Date(selectedDate[0] * 1000);
            let date2 = new Date(selectedDate[1] * 1000);
            link.download =
              "Log" +
              "_" +
              this.dev_fid +
              "_" +
              date1.getDate() +
              "." +
              (date1.getMonth() + 1) +
              "." +
              date1.getFullYear() +
              "—" +
              (+date2 !== 0
                ? +date2.getDate() +
                  "." +
                  (date2.getMonth() + 1) +
                  "." +
                  date2.getFullYear()
                : "") +
              ".txt";
            link.click();
            this.loading = false;
          },
          (bad_answer) => {
            this.bad_answer_handler(bad_answer);
            this.loading = false;
          }
        );
      }
    },
    disabledDate(date) {
      let today = new Date();
      return (
        date > new Date(today.getTime()) ||
        date <
          new Date(today.getTime() - this.datetime_picker * 24 * 3600 * 1000)
      );
    },
  },
};
</script>
<style lang='scss' scoped>
.logs {
  &_wrap {
    display: flex;
    flex-direction: column;
    overflow: hidden;
    height: 100%;

    .response_table {
      padding: 5px 0;
      table {
        th {
          i {
            opacity: 0;
            width: 0;
            display: inline-block;
          }
          &.selected {
            color: #000;
            i {
              opacity: 1;
              width: auto;
            }
          }
        }
      }
    }
  }
  &_field {
    height: 100%;
    width: 100%;
    overflow: auto;
    &::-webkit-scrollbar {
      width: 10px;
    }
  }
}

.mdi-arrow-down {
  transform: rotate(0);
  transition: 0.2s;
  &.reverse::before {
    transform: rotate(180deg);
  }
}

.log-panel {
  margin-bottom: 5px;
}
.archive {
  position: relative;
  z-index: 1;
  .v-spinner {
    margin: 0;
  }
}
.pointer {
  cursor: pointer;
}

.mx-icon-calendar, .mx-icon-clear {
  display: none ;
}

.arch_log {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;

  .filters {
    display: flex;
    justify-content: center;
    align-items: center;

    .filter {
      display: flex;
      justify-content: center;
      align-items: center;
      //flex-direction: column;
      min-width: 150px;
      margin-right: 10px;

      &.slider-switch {
        flex-direction: column;
        min-width: 100px;
      }
      &.date {
        width: 200px;
        margin-bottom: 0;
      }

      .form-group {
        margin: 0;
      }

      .info {
        margin-right: 5px;
        text-transform: full-width;
        min-inline-size: max-content;
      }

      .select {
        margin: 0;
        width: 120px;
      }

      .switch {
        position: relative;
        display: inline-block;
        width: 45px;
        height: 22px;
        margin-bottom: 0;
      }
      .switch input {
        display: none;
      }
      .slider {
        position: absolute;
        cursor: pointer;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: #ccc;
        -webkit-transition: 0.4s;
        transition: 0.4s;
      }

      .slider:before {
        position: absolute;
        content: "";
        height: 16px;
        width: 16px;
        left: 6px;
        bottom: 3px;
        background-color: white;
        -webkit-transition: 0.4s;
        transition: 0.4s;
      }

      input:checked + .slider {
        background-color: #41b883;
      }

      input:focus + .slider {
        box-shadow: 0 0 1px #41b883;
      }

      input:checked + .slider:before {
        transform: translateX(18px);
      }

      .slider.round {
        border-radius: 34px;
      }

      .slider.round:before {
        border-radius: 50%;
      }
    }
  }
  .mx-datepicker-range{
    width: auto;
  }
}

@media (max-width: 768px) {
  .arch_log .filters {
    flex-wrap: wrap;
    justify-content: flex-end;
    .filter {
      justify-content: flex-end;
      margin-bottom: 5px;
    }
  }
}
</style>
